/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ current: NonNullable<unknown>, total: NonNullable<unknown> }} Onboarding_Step_CounterInputs */



/**
* | output |
* | --- |
* | "Step {current} of {total}" |
*
* @param {Onboarding_Step_CounterInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const onboarding_step_counter = /** @type {((inputs: Onboarding_Step_CounterInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Step_CounterInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Schritt ${i?.current} von ${i?.total}`)
	return /** @type {LocalizedString} */ (`Step ${i?.current} of ${i?.total}`)
});